const APIGenericRequest = {};

// GET Requests

APIGenericRequest["getAllCivilStatus"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/civil-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getCivilStatusById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/civil-status/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllEducationLevels"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/education-level', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getEducationLevelById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/education-level/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllSex"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/sex', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getSexById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/sex/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllRegions"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/region', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getRegionById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/region/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}


APIGenericRequest["getAllProvinces"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/province', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllProvincesByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch('/api/lib/province/region/' + rid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getProvinceById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/province/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllCities"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/city', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllCitiesByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch('/api/lib/city/province/' + pid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getCityById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/city/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllBarangays"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/barangay', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllBarangaysByCityId"] = async (accessToken, cid) => {
	try {
		const response = await fetch('/api/lib/barangay/city/' + cid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getBarangayById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/barangay/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getAllExtensionNames"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/extension-name', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIGenericRequest["getServerDateTime"] = async (accessToken) => {
	try {
		const response = await fetch('/api/server/date-time', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIGenericRequest
